module.exports = __webpack_public_path__ + "static/media/two.7cd15ac5.jpg";